import { Listbox, Transition } from '@headlessui/react'
import { ChevronUpDownIcon, CheckIcon } from '@heroicons/react/20/solid'

export default function MacroVolumeFocusTypeDropdown({
    allowAll = true,
    editable = true,
    macroVolumeFocusTypeHashMap={},
    selectedMacroVolumeFocusTypeId,
    setSelectedMacroVolumeFocusTypeId
}) {
    if (
        macroVolumeFocusTypeHashMap === null 
        || Object.keys(macroVolumeFocusTypeHashMap).length === 0
    ) {
        return null
    }

    const isSelected = macroVolumeFocusTypeHashMap[selectedMacroVolumeFocusTypeId]
    const displayLabel = isSelected ? isSelected.name : (allowAll ? 'All focuses' : 'Select focus')
    const displayColor = isSelected ? isSelected.colorHex : '#9ca3af'

    if (!editable) {
        return (
            <div className='relative flex h-10 w-full items-center rounded-lg border border-gray-200 bg-gray-50 pl-3 pr-3 text-left text-sm'>
                <span className='flex items-center gap-x-2 truncate'>
                    <span
                        className='h-3 w-3 flex-shrink-0 rounded-full'
                        style={{ backgroundColor: displayColor }}
                    />
                    <span className='block truncate text-gray-700'>
                        {displayLabel}
                    </span>
                </span>
            </div>
        )
    }

    return (
        <Listbox
            value={selectedMacroVolumeFocusTypeId}
            onChange={setSelectedMacroVolumeFocusTypeId}
        >
            <div className='relative w-full'>
                <Listbox.Button className='relative flex h-10 w-full items-center cursor-pointer rounded-lg border border-gray-300 bg-white pl-3 pr-10 text-left text-sm shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-orange-500 shadow-md'>
                    {(() => {
                        const selected = macroVolumeFocusTypeHashMap[selectedMacroVolumeFocusTypeId]

                        return (
                            <span className='flex items-center gap-x-2 truncate'>
                                <span
                                    className='h-3 w-3 flex-shrink-0 rounded-full'
                                    style={{ backgroundColor: selected ? selected.colorHex : '#9ca3af' }}
                                />
                                <span className='block truncate'>
                                    {selected ? selected.name : (allowAll ? 'All focuses' : 'Select focus')}
                                </span>
                            </span>
                        )
                    })()}

                    <span className='pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2'>
                        <ChevronUpDownIcon className='h-5 w-5 text-gray-400' />
                    </span>
                </Listbox.Button>

                <Transition
                    as="div"
                    leave='transition ease-in duration-100'
                    leaveFrom='opacity-100'
                    leaveTo='opacity-0'
                >
                    <Listbox.Options className='absolute z-50 mt-1 max-h-60 w-full overflow-auto rounded-lg border border-gray-200 bg-white py-1 text-sm shadow-lg focus:outline-none'>
                        {allowAll &&
                            <Listbox.Option
                                value='all'
                                className={({ active }) =>
                                    `relative cursor-pointer select-none py-2 pl-3 pr-9 ${active ? 'bg-orange-50' : ''}`
                                }
                            >
                                {({ selected }) => (
                                    <>
                                        <span className='flex items-center gap-x-2'>
                                            <span className='h-3 w-3 flex-shrink-0 rounded-full bg-gray-400' />
                                            <span className={`block truncate ${selected ? 'font-semibold' : 'font-normal'}`}>
                                                All focuses
                                            </span>
                                        </span>

                                        {selected &&
                                            <span className='absolute inset-y-0 right-0 flex items-center pr-2 text-orange-600'>
                                                <CheckIcon className='h-5 w-5' />
                                            </span>
                                        }
                                    </>
                                )}
                            </Listbox.Option>
                        }

                        {Object.entries(macroVolumeFocusTypeHashMap)
                            .sort(([, a], [, b]) => a.sortOrder - b.sortOrder)
                            .map(([macroVolumeFocusTypeId, macroVolumeFocusType]) => (
                                <Listbox.Option
                                    key={macroVolumeFocusTypeId}
                                    value={parseInt(macroVolumeFocusTypeId)}
                                    className={({ active }) =>
                                        `relative cursor-pointer select-none py-2 pl-3 pr-9 ${active ? 'bg-orange-50' : ''}`
                                    }
                                >
                                    {({ selected }) => (
                                        <>
                                            <span className='flex items-center gap-x-2'>
                                                <span
                                                    className='h-3 w-3 flex-shrink-0 rounded-full'
                                                    style={{ backgroundColor: macroVolumeFocusType.colorHex }}
                                                />
                                                <span className={`block truncate ${selected ? 'font-semibold' : 'font-normal'}`}>
                                                    {macroVolumeFocusType.name}
                                                </span>
                                            </span>

                                            {selected &&
                                                <span className='absolute inset-y-0 right-0 flex items-center pr-2 text-orange-600'>
                                                    <CheckIcon className='h-5 w-5' />
                                                </span>
                                            }
                                        </>
                                    )}
                                </Listbox.Option>
                            ))}
                    </Listbox.Options>
                </Transition>
            </div>
        </Listbox>
    )
}
